import React, { useEffect } from 'react'
import useStore from './store'
import useQueries from './hooks/use-queries'
import {
  categoriesQuery,
  locationsQuery,
  residentsQuery,
  campusesQuery,
} from './graphql/queries'
import AppConfig from '@/app-config.js'
//import useIdle from './hooks/use-idle'
import TableView from '@/components/table-view'
import MainControls from '@/components/main-controls'
import Modal from '@/components/modal'
import Message from './components/message'

function App() {
  const modals = useStore((state) => state.modals)
  const setLocationsData = useStore((state) => state.setLocationsData)
  const setCategoriesData = useStore((state) => state.setCategoriesData)
  const setResidentsData = useStore((state) => state.setResidentsData)
  const setCampusesData = useStore((state) => state.setCampusesData)
  //const setIsIdle = useStore((state) => state.setIsIdle)
  const setSounds = useStore((state) => state.setSounds)

  const mode = (() => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('mode') === 'preview' ? 'PREVIEW' : 'LIVE'
  })()

  const queries = ['categoriesQuery', 'locationsQuery', 'residentsQuery', 'campusesQuery']
  queries.forEach((which) => {
    fetch(`${AppConfig.apiUrl}/${which}.json`).then((result) => result.json())
        .then((result) => result.data).then((result) => {
        result.categories && setCategoriesData(result.categories.data)
        result.locations && setLocationsData(result.locations.data)
        result.residents && setResidentsData(result.residents.data)
        result.campuses && setCampusesData(result.campuses.data)
    })
  })

 // const isIdle = useIdle(24 * 12 * 5 * 60000)

  useEffect(() => {
    setSounds([{ click1: 'click1.mp3' }, { click2: 'click2_appear.mp3' }])
    // eslint-disable-next-line
  }, [])

 // useEffect(() => setIsIdle(isIdle), [isIdle, setIsIdle])

  return (
    <div className="App">
      <TableView />
      <Modal side="top" {...modals.top} />
      <Modal side="bottom" {...modals.bottom} />
      <MainControls side="top" />
      <MainControls side="bottom" />
      <Modal side="main" {...modals.main} />
    </div>
  )
}

export default React.memo(App)
